import config from 'SrcConfig'
import Num2persian from 'num2persian'
import { accounting } from 'accounting'

export const converter = (
  amount,
  rate = config.currency.rates[config.currency.display],
  symbol = ''
) => {
  return accounting.formatMoney(amount / rate, symbol, ',')
}

export const toAlphabet = (amount, symbol = null) => {
  return amount ? `${Num2persian(amount)}${symbol ? ` ${symbol}` : ''}` : amount
}
